// extracted by mini-css-extract-plugin
module.exports = {"container":"L1I2mtIwMyHv9ifdSfOeX"};